import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import logo from '../../img/logo/logo_light.svg';
import { resetPasswordRequest } from '../../redux/actions/authActions';
import PasswordResetForm from './forms/PasswordResetForm';
import PasswordResetEmailSent from './components/PasswordResetEmailSent';
import { isMobile } from 'react-device-detect';
import AppBarPortal from '../shared/components/AppBarPortal';
import AppFooterPortal from '../shared/components/AppFooterPortal';
import AppLeftPortal from '../shared/components/AppLeftPortal';
import PrivacyPolicyLink from '../shared/components/PrivacyPolicyLink';
import AppBarLandingMobile from '../shared/components/AppBarLandingMobile';
import DrawerLandingMobile from '../shared/components/DrawerLandingMobile';

const styles = theme => ({
  root: {
    display: 'flex', 
    justifyContent: 'space-around', 
    alignItems: 'stretch', 
    flexFlow: 'column wrap'
  },
  item: {
    flexBasis: 'initial',
    flexGrow: 1,
    display: 'inline-flex'
  },
  buttonTeal: theme.custom.button.teal
})

class PasswordReset extends React.PureComponent {

  state = {
    email: ''
  }

  submit = values => {
    console.debug(values);

    this.setState({
      email: values.email
    })

    let data = new FormData();
    data.set('email', values.email)
    this.props.dispatch(resetPasswordRequest(data))
  } 

  componentDidMount() {
    document.body.classList.add("login");
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render() {
    const { classes, auth } = this.props
    const initiated = auth.password_request_initiated;

    return (
      <React.Fragment>
        {!isMobile && <AppBarPortal />}
        {!isMobile && <AppLeftPortal />}
        {!isMobile && <AppFooterPortal />}

        {isMobile && <AppBarLandingMobile />}
        {isMobile && <DrawerLandingMobile />}
        <main>
          <Grid container className={classes.root} spacing={8} alignItems="center">

            <Grid item xs={12} className={classes.item} style={{flexGrow: 1, justifyContent: 'center'}}>
              <img src={logo} style={{maxHeight: 36}} />
            </Grid>

            {initiated === false && 
            <React.Fragment>
              <Grid item xs={12} className={classes.item} style={{flexGrow: 1, alignItems: 'flex-end', justifyContent: 'center'}}>
                <Typography variant='headline'>Restablecer contraseña</Typography>
              </Grid>

              <Grid item xs={12} className={classes.item} style={{flexGrow: 4, alignItems: 'center'}}>
                <PasswordResetForm onSubmit={this.submit} {...this.props} />
              </Grid>
            </React.Fragment>
            }

            {initiated && 
              <PasswordResetEmailSent email={this.state.email} />
            }

            <Grid item xs={12} className={classes.item} style={{flexGrow: 1, alignItems: 'flex-end', justifyContent: 'center'}}>
              <PrivacyPolicyLink />
            </Grid>

          </Grid>
        </main>
      </React.Fragment>
    )
  }
}

export default connect(state => ({
  auth: state.auth
}))(withRouter(
  withStyles(styles, {withTheme: true})(PasswordReset)
));


// WEBPACK FOOTER //
// ./src/modules/auth/PasswordReset.js